import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchSingleProductByCode } from "../../slice/productSlice";
import ProductDetailView from "../../components/product/ProductDetailView";
import { getVendorIdFromToken } from "../../helpers/utils";

const PENDING_PRODUCT_CODE_KEY = "pendingProductCode";
const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect";

const ProductByCode = () => {
  const dispatch = useDispatch();
  const { productCode } = useParams();
  const navigate = useNavigate();
  const {
    singleProductState: { data: product, loading, error },
  } = useSelector((state) => state.productLists);

  useEffect(() => {
    const vendorId = getVendorIdFromToken();
    const decodedCode = decodeURIComponent(productCode || "");

    if (!vendorId) {
      sessionStorage.setItem(PENDING_PRODUCT_CODE_KEY, decodedCode);
      sessionStorage.setItem(
        POST_LOGIN_REDIRECT_KEY,
        `/product-detail/${encodeURIComponent(decodedCode)}`
      );
      navigate(
        `/auth?redirect=product-detail/${encodeURIComponent(decodedCode)}`
      );
      return;
    }

    dispatch(
      fetchSingleProductByCode({ productCode: decodedCode, vendorId })
    );
  }, [productCode, dispatch, navigate]);

  return <ProductDetailView product={product} loading={loading} error={error} />;
};

export default ProductByCode;
